import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { FullscreenLoader } from "@/components/ui/loader";

export const Route = createFileRoute("/")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "HAMS — Hospital Asset Management" },
      { name: "description", content: "Asset registry, work orders, compliance & audit for hospitals." },
    ],
  }),
  component: Landing,
});

function Landing() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { isAuthenticated, getMe } = await import("@/integrations/api/auth");
        if (isAuthenticated()) {
          const me = await getMe();
          if (cancelled) return;
          const { homePathForRoles } = await import("@/lib/roles");
          navigate({ to: homePathForRoles(me.roles) });
          return;
        }
      } catch {
        // Not logged in or session expired
      }
      if (!cancelled) {
        navigate({ to: "/auth" });
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  return <FullscreenLoader />;
}
